import { APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { HttpClientModule, HttpClientXsrfModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { NgEventBus } from 'ng-event-bus';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { NgwWowModule } from 'ngx-wow';
import { SharedModule } from './shared/shared.module';
import { ToastAlertService } from './shared/utils/toast.service';

import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { ProtectedLayoutFooterComponent } from './layouts/protected/protected-layout-footer/protected-layout-footer.component';
import { ProtectedLayoutHeaderComponent } from './layouts/protected/protected-layout-header/protected-layout-header.component';
import { ProtectedLayoutWrapperComponent } from './layouts/protected/protected-layout-wrapper/protected-layout-wrapper.component';
import { ConsentPromptComponent } from './layouts/protected/consent-prompt/consent-prompt.component';
import { CoreModule } from './core/core.module';
import { NgxSpinnerModule } from "ngx-spinner";
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { PipesModule } from './shared/pipes/pipes.module';
import { Router } from "@angular/router";
import { PublicLayoutWrapperV2Component } from './layouts/public/public-layout-wrapper-v2/public-layout-wrapper-v2.component';
import { PublicLayoutHeaderV2Component } from './layouts/public/public-layout-header-v2/public-layout-header-v2.component';
import { PublicLayoutFooterV2Component } from './layouts/public/public-layout-footer-v2/public-layout-footer-v2.component';
import { PublicLayoutHeaderComponent } from './layouts/public/public-layout-header/public-layout-header.component';
import { PublicLayoutFooterComponent } from './layouts/public/public-layout-footer/public-layout-footer.component';
import { PublicLayoutWrapperComponent } from './layouts/public/public-layout-wrapper/public-layout-wrapper.component';
import { PowerPitchEditPageWrapperComponent } from './modules/pitch-deck-management/power-pitch-edit-page-wrapper/power-pitch-edit-page-wrapper.component';
import { SocketIoModule } from 'ngx-socket-io';
import { InlineStylesCspModule } from './modules/inline-styles-csp/inline-styles-csp.module';
import { PublicHeaderLogoOnlyComponent } from './layouts/public/public-header-logo-only/public-header-logo-only.component';
import { CouponComponent } from './modules/payment/coupon/coupon.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BillingFormComponent } from './modules/payment/billing-form/billing-form.component';
import { ChallengePublicViewComponent } from './modules/challenge-public-view/challenge-public-view.component';
import { ChallengeCollectionComponent } from './modules/challenge-collection/challenge-collection.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import * as Sentry from '@sentry/angular-ivy';
import { environment } from '../environments/environment';
// import { StaticFormFieldComponent } from './modules/static-form-field/static-form-field.component';

@NgModule({
  declarations: [
    AppComponent,
    ProtectedLayoutHeaderComponent,
    ProtectedLayoutWrapperComponent,
    ConsentPromptComponent,
    ProtectedLayoutFooterComponent,
    PublicLayoutWrapperV2Component,
    PublicLayoutHeaderV2Component,
    PublicLayoutFooterV2Component,

    PublicLayoutHeaderComponent,
    PublicLayoutFooterComponent,
    PublicLayoutWrapperComponent,
    PowerPitchEditPageWrapperComponent,
    PublicHeaderLogoOnlyComponent,
  ],
  imports: [
    BrowserModule,
    FormsModule,
    BrowserAnimationsModule,
    HttpClientModule,
    HttpClientXsrfModule,
    SweetAlert2Module.forRoot(),
    AppRoutingModule,
    SharedModule,
    NgbModule,
    NgxDropzoneModule,
    NgwWowModule,
    CoreModule,
    NgxSpinnerModule,
    LazyLoadImageModule,
    PipesModule,
    SocketIoModule.forRoot({
      url: ''
    }),
    InlineStylesCspModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000'
    })
  ],
  providers: [
    NgEventBus,
    ToastAlertService,
    { provide: ErrorHandler, useValue: Sentry.createErrorHandler({ showDialog: false }) },
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule {
}
